import "./App.css";
import Dictionary from "./Dictionary.js";

export default function App() {
  return <Dictionary />;
}
